import { render, staticRenderFns } from "./GenerationAlertModal.vue?vue&type=template&id=28823b2d&scoped=true&"
import script from "./GenerationAlertModal.vue?vue&type=script&lang=ts&"
export * from "./GenerationAlertModal.vue?vue&type=script&lang=ts&"
import style0 from "./GenerationAlertModal.vue?vue&type=style&index=0&id=28823b2d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28823b2d",
  null
  
)

export default component.exports